import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/Bg-uk-ios.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>
                Top-Grade iOS App Development Company in UK for Your Next
                Project
              </h2>
            </div>
            <p className="z_idx">
              Looking to enhance your business with top-notch iPhone apps in
              London? Look no further! TekRevol is your go-to{" "}
              <Link
                to="/uk/ios-app-development-company-london"
                rel="noopener"
                aria-label="TekRevol"
              >
                iOS app development company in London{" "}
              </Link>
              that brings expert iPhone app developers ready to transform your
              business. When you hire iOS app developer talent from TekRevol,
              you're ensuring a seamless and efficient app development process.
              We understand the ins and outs of crafting high-performance iPhone
              apps in London that align with your business goals.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
